import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { BlockUI, NgBlockUI } from "ng-block-ui";

// ContentHeader component interface
export interface ContentHeader {
  headerTitle: string;
  actionButton: boolean;
  breadcrumb?: {
    type?: string;
    links?: Array<{
      name?: string;
      isLink?: boolean;
      link?: string;
    }>;
  };
}

@Component({
  selector: "app-content-header",
  templateUrl: "./content-header.component.html",
})
export class ContentHeaderComponent implements OnInit {
  @BlockUI("page") blockUI: NgBlockUI;

  // input variable
  @Input() contentHeader: ContentHeader;
  // the new application link redirects to the link provided by this variable instead of /portal/affidavit/applications/start
  @Input() actionButtonLink: string;

  constructor(private router: Router) {}

  checkRouteContains(path: string): boolean {
       return this.router.url.includes(path);
  }


  ngOnInit() {}

  navigateToNewApplication() {
    this.blockUI.start('Loading...');
    this.router.navigate(['/portal/affidavit/applications/start']);
  }
}
